import React from "react";
import Header from "../../components/Layout/Header/Header";
import "../../pages/detailspage/DetailsPage.css";

const DetailsPage: React.FC = () => {
  return (
    <>
      <Header />

      <div className="details-container">
        <div className="details-content">
          <h1>About the Lifestyle Online Blog</h1>
          <p>
            Lifestyle Online is a modern blog platform focused on fashion, lifestyle, and content creation.
            Our blog provides readers with tips, insights, and inspiration to stay ahead in the
            creative world. Each article is carefully crafted to combine style, information, and
            practical advice.
          </p>
          <p>
            Whether you’re interested in the latest fashion trends, lifestyle hacks, or in-depth
            guides on content creation, Lifestyle Online delivers high-quality content in an elegant,
            easy-to-read format.
          </p>
          <p>
            The platform is fully responsive, user-friendly, and designed to provide a seamless
            experience across all devices. Dive into our posts to explore insightful stories,
            tips, and creative inspiration.
          </p>
        </div>
      </div>
    </>
  );
};

export default DetailsPage;
